import { $httpAdmin, $httpAdminSync } from "../../api/http";
import { type AxiosPromise } from "../../modules/axios";
import { isNullOrUndef } from "../../util/data";
import { pick } from "../../util/object";

export interface Custom {
  id: number;
  type: 'product' | 'news' | 'custom';
  platefo: number;
  sort: number;
  title: string;
  titlefo: number;
  content: string;
}

export function apiCustomGet(params?: null): AxiosPromise<Omit<Custom, 'content'>[]>;
export function apiCustomGet(params: { id: Custom['id']; }): AxiosPromise<Custom>;
export function apiCustomGet(params?: { id: Custom['id']; } | null): AxiosPromise<Omit<Custom, 'content'>[] | Custom> {
  if (isNullOrUndef(params?.id)) {
    return $httpAdmin.get('/title/mtzdyselect');
  }
  return $httpAdmin.post('/title/mtzdyone', undefined, { params });
}

export async function apiCustomAdd(params: Omit<Custom, 'id'>): Promise<AxiosPromise> {
  await $httpAdminSync.post('/title/mtzdyadd', params);
  return $httpAdmin.post('/title/mtzdyadd', params);
}

export async function apiCustomUpdate(params: Partial<Custom>): Promise<AxiosPromise> {
  await $httpAdminSync.patch('/title/mtzdyupdate', pick(params, ['id', 'content']));
  return $httpAdmin.patch('/title/mtzdyupdate', params);
}

export async function apiCustomDelete(id: Custom['id']): Promise<AxiosPromise> {
  await $httpAdminSync.delete(`/title/mtzdydeletebyid/${id}`);
  return $httpAdmin.delete(`/title/mtzdydeletebyid/${id}`);
}
